export default "RiddleRoom åbnede i februar 2017 og lukkede i starten af 2021.";